import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e8f376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-lg" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroup"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_6 = { class: "modal-body p-3" }
const _hoisted_7 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_8 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_9 = { class: "mx-0 px-0 col-lg-10 d-flex align-items-center text-break" }
const _hoisted_10 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_11 = { class: "w-max-content col-lg-2 fw-bold" }
const _hoisted_12 = { class: "mx-0 px-0 col-lg-10 d-flex align-items-center text-break break-spaces" }
const _hoisted_13 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_14 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_15 = { class: "mx-0 px-0 col-lg-10 col-form-label" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_20 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_21 = { class: "mx-0 px-0 col-lg-10 d-flex align-items-center" }
const _hoisted_22 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_23 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_24 = { class: "mx-0 px-0 col-lg-10 d-flex align-items-center" }
const _hoisted_25 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import dayjs from 'dayjs'
import { useRoute } from 'vue-router'
import Button from '@/components/button/index.vue'
import { getFileNameFromUrl } from '@/constants/regex'
import { blobDownload } from '@/utils'
import { usePath } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
},
  setup(__props) {



const route = useRoute()

const { path } = usePath()
const clickFile = async (fileUrl: string) => {
  // eslint-disable-next-line prettier/prettier
  const requestParams = ['request_path=' + path, 'community_id=' + route.params?.id, 'type=community_message']

  const blob = await fetch(fileUrl + '?' + requestParams.join('&'), { credentials: 'include' }).then((r) => r.blob())
  const fileName = getFileNameFromUrl(fileUrl)
  blobDownload(blob, fileName)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(translate)('messageHistory')), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('title')), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data?.title), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('content')), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.data?.content), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('OE65attachment')), 1),
          _createElementVNode("div", _hoisted_15, [
            (__props.data?.file_url_1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (clickFile(__props.data?.file_url_1))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(__props.data?.file_url_1)), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.data?.file_url_2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (clickFile(__props.data?.file_url_2))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(__props.data?.file_url_2)), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.data?.file_url_3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (clickFile(__props.data?.file_url_3))),
                    href: "javascript:void(0)"
                  }, _toDisplayString(_unref(getFileNameFromUrl)(__props.data?.file_url_3)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('OE65deliverRange')), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(!__props.data?.send_mail ? _unref(translate)('OE50personal') : _unref(translate)('OE50personalEmail')), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('OE65deliverDate')), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(dayjs)(__props.data?.booking_date).format('YYYY/MM/DD HH:mm:ss')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(Button, {
          title: _unref(translate)('close'),
          type: 'secondary',
          "data-bs-dismiss": "modal"
        }, null, 8, ["title"])
      ])
    ])
  ]))
}
}

})